import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Logo } from 'src/components/atoms/Logo/Logo';
import style from './Footer.module.scss';

export const Footer: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <footer className={style.footer}>
      <div className={`container ${style.inner}`}>
        <div className={style.brand}>
          <Logo full />
          <p className={style.tagline}>{t('footer.tagline')}</p>
        </div>
        <nav aria-label={t('footer.nav')} className={style.links}>
          <Link to="/terms" className={style.link}>
            {t('footer.terms')}
          </Link>
          <Link to="/privacy" className={style.link}>
            {t('footer.privacy')}
          </Link>
        </nav>
        <div className={style.legal}>
          <div className={style.notes}>
            <p>{t('footer.rights')}</p>
            <p>{t('footer.adults')}</p>
            <p>© {new Date().getFullYear()} Earworm</p>
            <p>{t('footer.version', { version: import.meta.env.VITE_APP_VERSION || 'dev' })}</p>
          </div>
          <a href="https://ogarich89.com" target="_blank" rel="noopener noreferrer" className={style.author}>
            {t('footer.author')}
          </a>
        </div>
      </div>
    </footer>
  );
};
